<script>
import { isValidNumber } from 'libphonenumber-js'
import { required, email } from 'vuelidate/lib/validators'
import TweenMax from 'TweenMax'
import { Power2 } from 'EasePack'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

import formMixin from '../../library/form'
import { DURATION } from '../../constants'

import Gallery from '../../components/content/Gallery'

export default {
  components: {
    Gallery,
  },

  mixins: [formMixin],
  props: {
    gaSuccessUrl: {type: String, default: null},
  },
  mounted () {
    this.$el.querySelector('button').addEventListener('click', event => {
      TweenMax.to(window, DURATION * 2, {scrollTo: '#content', ease: Power2.easeOut})
    })
  },
  methods: {
    getValidations () {
      return {
        name: { required },
        company: {},
        email: { required, email },
        phone: {
          phonenumber: function (value) {
            return (value) ? isValidNumber(value) : true
          }
        },
        location: {},
        country: { required },
        products: {},
        message: {},
      }
    },
    // afterSuccess (data) {
    //   let label = 'No product selected'
    //   if (this.formData.products.length) label = this.formData.products[0].name
    //   gtag('event', 'product_inquiry_sent', {'event_label': label});
    // }
  }
}
</script>



// WEBPACK FOOTER //
// assets/js/components/products/ProductInquiryForm.vue